// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3wIkb","fileBtn":"File_fileBtn__1zu91","closeBtn":"File_closeBtn__3UP-r","fileSelected":"File_fileSelected__PrNlG","disabled":"File_disabled__187-p"};